import { instance } from '../helper/api'

export const getHODByRequestor = async customerId => {
  let resultData = {}
  const axiosConfig = {
    url: `/v1/customer/approval/detail/?customer_id=${customerId}`,
    method: 'GET'
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}
